module.exports = __webpack_public_path__ + "static/img/3s-info-2.fff7e15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-2.png
// module id = kggS
// module chunks = 0